import { createSlice } from "@reduxjs/toolkit";

export const enquirySlice = createSlice({
  name: "enquiry",
  initialState: {
    postLoading: false,
    postError: false,
    postStatusCode: 0,
    postMessage: "",
    getLoading: false,
    getError: false,
    getData: null,
    getMessage: "",
    getStatusCode: 0,
    updateLoading: false,
    updateError: false,
    updateStatusCode: 0,
    updateMessage: "",
    viewLoading: false,
    viewError: false,
    viewStatusCode: 0,
  },
  reducers: {
    onEnquiryPost: (state) => ({
      ...state,
      postLoading: true,
      postError: false,
      postStatusCode: 0,
      postMessage: "",
    }),
    onEnquiryPostSuccess: (state, { payload }) => {
      const { message = "", status_code = 200 } = payload;
      return {
        ...state,
        postLoading: false,
        postError: false,
        postStatusCode: status_code,
        postMessage: message,
      };
    },
    onEnquiryPostError: (state, { payload }) => {
      const { message = "", status_code = 400 } = payload;
      return {
        ...state,
        postLoading: false,
        postError: true,
        postStatusCode: status_code,
        postMessage: message,
      };
    },
    onEnquiryPostReset: (state) => ({
      ...state,
      postLoading: false,
      postError: false,
      postStatusCode: 0,
      postMessage: "",
    }),
    onGetEnquiries: (state) => ({
      ...state,
      getLoading: true,
      getError: false,
      getData: null,
      getMessage: "",
      getStatusCode: 0,
    }),
    onGetEnquiriesSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload;
      return {
        ...state,
        getLoading: false,
        getError: false,
        getData: data,
        getMessage: message,
        getStatusCode: status_code,
      };
    },
    onGetEnquiriesError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload;
      return {
        ...state,
        getLoading: false,
        getError: true,
        getData: data,
        getMessage: message,
        getStatusCode: status_code,
      };
    },
    onGetEnquiriesReset: (state) => ({
      ...state,
      getLoading: false,
      getError: false,
      getData: null,
      getMessage: "",
      getStatusCode: 0,
    }),
    onEnquiryUpdate: (state) => ({
      ...state,
      updateLoading: true,
      updateError: false,
      updateStatusCode: 0,
      updateMessage: "",
    }),
    onEnquiryUpdateSuccess: (state, { payload }) => {
      const { message = "", status_code = 200 } = payload;
      return {
        ...state,
        updateLoading: false,
        updateError: false,
        updateStatusCode: status_code,
        updateMessage: message,
      };
    },
    onEnquiryUpdateError: (state, { payload }) => {
      const { message = "", status_code = 400 } = payload;
      return {
        ...state,
        updateLoading: false,
        updateError: true,
        updateStatusCode: status_code,
        updateMessage: message,
      };
    },
    onEnquiryUpdateReset: (state) => ({
      ...state,
      updateLoading: false,
      updateError: false,
      updateStatusCode: 0,
      updateMessage: "",
    }),
    onEnquiryView: (state) => ({
      ...state,
      viewLoading: true,
      viewError: false,
      viewStatusCode: 0,
    }),
    onEnquiryViewSuccess: (state, { payload }) => {
      const { status_code = 200 } = payload ?? {};
      return {
        ...state,
        viewLoading: false,
        viewError: false,
        viewStatusCode: status_code,
      };
    },
    onEnquiryViewError: (state, { payload }) => {
      const { status_code = 400 } = payload ?? {};
      return {
        ...state,
        viewLoading: false,
        viewError: true,
        viewStatusCode: status_code,
      };
    },
  },
});

export const {
  onEnquiryPost,
  onEnquiryPostSuccess,
  onEnquiryPostError,
  onEnquiryPostReset,
  onGetEnquiries,
  onGetEnquiriesSuccess,
  onGetEnquiriesError,
  onGetEnquiriesReset,
  onEnquiryUpdate,
  onEnquiryUpdateSuccess,
  onEnquiryUpdateError,
  onEnquiryUpdateReset,
  onEnquiryView,
  onEnquiryViewSuccess,
  onEnquiryViewError,
} = enquirySlice.actions;

export default enquirySlice.reducer;
